// extracted by mini-css-extract-plugin
export var infoItem = "_t5-2";
export var title = "_t5-0";
export var value = "_t5-1";